export enum IButtonActionType {
    SaveAction,
    UrlLink,
    PostMethod,
    PostWithBlobResponse
}
